import { CmsApplianceDetailsForm } from '../../models/appliance-details-stepped/cms/cms-appliance-details.interface';
import { mockCmsApplianceDetailsNultiFieldList } from './cms-appliance-details-multi-field-list.mock';

export const mockCmsApplianceDetailsForm: CmsApplianceDetailsForm = {
  applianceCategoryField: {
    fieldLabel: 'Which appliance can we help you with?',
    fieldRequired: true,
    multiFieldList: [mockCmsApplianceDetailsNultiFieldList],
  },
  applianceCodeField: {
    fieldLabel: 'Can you tell us what type of appliance it is?',
    fieldRequired: true,
  },
  popularVideosBlock: {
    '@name': '',
    '@path': '',
    popularVideos: [],
    popularVideosBody: '',
    popularVideosTitle: '',
    viewAllVideosLink: { href: '' },
  },
};
